import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20cultural%20atmosphere%2C%20warm%20ambient%20lighting%20in%20traditional%20room%20with%20modern%20elements%2C%20soft%20beige%20cream%20and%20warm%20brown%20tones%2C%20artistic%20abstract%20composition%2C%20serene%20contemplative%20mood%2C%20high%20quality%20editorial%20photography%20style&width=1600&height=900&seq=hero-hitozuma-main&orientation=landscape"
        alt="Hitozuma 文化专题导览"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight max-w-3xl">
          Hitozuma 文化深度解析
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl leading-relaxed mb-8">
          全面、专业的信息导览与资源索引，带您深入了解 hitozuma 文化的定义、分类、作品解析与文化背景
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/basics"
            className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center gap-8 flex-wrap justify-center">
          {[
            { label: '分类模块', value: '5' },
            { label: '深度文章', value: '40+' },
            { label: '资源索引', value: '100+' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white font-heading">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-white/70 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}